module.exports = __webpack_public_path__ + "img/太魯閣.31b81195.jpg";